import { Component, computed, inject, signal } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { PaginatorStateService } from '../../../../services/paginator/paginator-state.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { CallToActionComponent } from '../call-to-action/call-to-action.component';
import { FeaturedAuctionsComponent } from '../featured-auctions/featured-auctions.component';
import { MainGoodmeterComponent } from '../main-goodmeter/main-goodmeter.component';
import { ItemCategoriesComponent } from '../item-categories/item-categories.component';
import { PaginatorModule } from 'primeng/paginator';
import { FeaturedItemsComponent } from '../featured-items/featured-items.component';
import { IItem } from '../../../../models/IItem';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-main-content',
  imports: [
    ProgressSpinnerModule,
    CommonModule,
    CallToActionComponent,
    FeaturedAuctionsComponent,
    MainGoodmeterComponent,
    ItemCategoriesComponent,
    PaginatorModule,
    FeaturedItemsComponent
  ],
  providers: [DynamicDialogRef],
  templateUrl: './main-content.component.html',
  styleUrl: './main-content.component.scss'
})
export class MainContentComponent {
  firstSignal = signal(0);
  itemList: IItem[] = [];

  protected defaultItemsSort = computed(() => 'NAME_DESC'
    // this.apiService.auctionConfigSignal()?.defaultItemsSort ?? 'NAME_DESC'
  );
  // Signal store filters
  filters = signal({
    sort: this.defaultItemsSort(),
    categoryId: [] as number[],
    page: 1,
    per: 30,
    q: '',
    dynamicCategory: ''
  });

  rowsPerPageOptions = [ 15, 30, 60, 90];
  paginatedItems: any[] = [];


  private readonly apiService = inject(ApiService)
  paginatorService = inject(PaginatorStateService);
  pagination = this.paginatorService.getPagination();

  totalItemsSignal = computed(() => this.apiService.itemsSignal().totalItems);


  //constructor(private apiService: ApiService) {
  //}

  onPageChange(event: any) {
    this.filters.update(filters => ({
      ...filters,
      page: event.page + 1,
      per: event.rows
    }));


    this.firstSignal.set(event.first);

    this.paginatorService.setPagination(event.page + 1, event.rows);

    this.pagination = {
      page: event.page + 1,
      per: event.rows
    };
  }
}
